import { Node } from 'reactflow';

const EMPTY: readonly Node[] = Object.freeze([]);

let source: Node[] | null = null;
let buckets = new Map<string, Node[]>();

/**
 * The nodes belonging to one sub-layer, grouped once per version of the canvas
 * `nodes` array and shared by every sub-layer view.
 *
 * A mode has 7 to 9 sub-layers and each one needs its own bucket, so grouping
 * is done in a single pass they all share rather than one filter apiece.
 * Correct because the store replaces `nodes` rather than mutating it, which
 * makes array identity a sound cache key. The bucket is shared with every other
 * caller, hence `readonly`: sorting or pushing it would corrupt the index.
 */
export const getSubLayerNodes = (
  nodes: Node[],
  subLayerId: string,
): readonly Node[] => {
  if (nodes !== source) {
    source = nodes;
    buckets = new Map<string, Node[]>();

    nodes.forEach((node) => {
      if (!node.parentNode) return;

      const bucket = buckets.get(node.parentNode);

      if (bucket) bucket.push(node);
      else buckets.set(node.parentNode, [node]);
    });
  }

  return buckets.get(subLayerId) ?? EMPTY;
};
